import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { OverflowTooltipDirective } from '@directives/overflow-tooltip.directive';

@Component({
  selector: 'abb-image-value-cell',
  standalone: true,
  template: `
    @if(image()) {
    <div class="flex flex-row gap-3">
      <span
        class="self-center bg-center bg-cover bg-no-repeat rounded-full w-8 h-8 flex-shrink-0"
        [ngStyle]="{ backgroundImage: 'url(' + image() + ')' }"
      ></span>
      <span overflowTooltip class="block flex-1 content-center truncate">
        {{ value() }}
      </span>
    </div>
    } @else {
    <div class="flex flex-row gap-3">
      <div class="inline-flex flex-row items-center justify-center">
        <div
          class="w-8 h-8 flex-shrink-0 text-[15px] leading-[15px] rounded-full bg-abb-gray-02 text-abb-white content-center text-center"
        >
          {{ userBadgeLabel() }}
        </div>
      </div>
      <span overflowTooltip class="block flex-1 content-center truncate">
        {{ value() }}
      </span>
    </div>
    }
  `,
  imports: [CommonModule, OverflowTooltipDirective],
  styles: ``,
})
export class ImageValueCellComponent {
  value = input.required<string>();
  image = input<string | null | undefined>();
  userBadgeLabel = computed(() =>
    this.value()
      ?.split(' ')
      ?.map((w: string) => w[0]?.toUpperCase())
      .join('')
  );
}
